import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from './firebase';
import './Garments.css';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { BsArrowReturnLeft } from 'react-icons/bs';

const Garments = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            if (user) {
                const fetchProducts = async () => {
                    console.log("Fetching products for vendor:", user.uid);
                    try {
                        const response = await fetch(`https://getgarments-fr7xfbboya-uc.a.run.app?vendorId=${user.uid}`);
                        const data = await response.json();
                        if (data.status === 'success') {
                            setProducts(data.data);
                        }
                    } catch (error) {
                        console.error("Error fetching products:", error);
                    } finally {
                        setLoading(false);
                    }
                };
                fetchProducts();
            } else {
                // Handle case where there is no user
                setLoading(false);
            }
        });

        return () => unsubscribe();
    }, []);

    const handleEdit = (product) => {
        navigate('/upload', { state: { product } });
    };

    const handleUnpublish = async (product) => {
        const ok = window.confirm('Remove this product from the online store?');
        if (!ok) return;

        try {
            const user = auth.currentUser;
            if (!user) {
                alert('You must be signed in to do that.');
                return;
            }

            const idToken = await user.getIdToken();

            const response = await fetch('https://unpublishproduct-fr7xfbboya-uc.a.run.app', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${idToken}`,
                },
                body: JSON.stringify({ productId: product.id }),
            });

            const data = await response.json().catch(() => null);
            if (!response.ok || !data || data.status !== 'success') {
                const message = data?.message || response.statusText || 'Failed to unpublish product';
                throw new Error(message);
            }

            setProducts((prev) => prev.filter((p) => p.id !== product.id));
        } catch (error) {
            console.error('Error unpublishing product:', error);
            alert(`Failed to unpublish: ${error.message}`);
        }
    };

    if (loading) {
        return (
            <div className="loading-spinner-container">
                <div className="loading-spinner"></div>
            </div>
        );
    }

    return (
        <div className="garments-container">
            <header className="garments-header">
                <h1 className="garments-title">
                    <button
                        type="button"
                        className="garments-back-button"
                        onClick={() => navigate('/')}
                        aria-label="Back to home"
                    >
                        <BsArrowReturnLeft />
                    </button>
                    <span>My Garments</span>
                </h1>
                <p className="garments-subtitle">
                    Can't see your product yet? That means it is pending approval by the AYLA team, we thank you for your patience.
                </p>
            </header>
            <div className="product-grid">
                {products.map(product => (
                    <div key={product.id} className="product-card">
                        <div className="product-card-buttons">
                            <button onClick={() => handleEdit(product)} aria-label="Edit">
                                <FaPencilAlt />
                            </button>
                            <button onClick={() => handleUnpublish(product)} aria-label="Unpublish">
                                <FaTrash />
                            </button>
                        </div>
                        <img src={product.images.edges[0]?.node.originalSrc} alt={product.title} />
                        <h2>{product.title}</h2>
                    </div>
                ))}
                <Link to="/upload" className="add-garment-card">
                    <div className="add-garment-plus">+</div>
                </Link>
            </div>
        </div>
    );
};

export default Garments;
